module.exports = __webpack_public_path__ + "static/media/image-video-2.ec4a0fa6.png";